var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "commonField", class: { oneline: _vm.oneline } },
    [
      _c("div", { staticClass: "label" }, [
        _c("div", { staticClass: "circle" }),
        _vm.showLabel ? _c("span", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
      ]),
      _c(
        "div",
        {
          staticClass: "box",
          class: { nodata: _vm.nodata, "show-errorMsg": _vm.errorMsg },
        },
        [
          _c("van-field", {
            style: { marginRight: _vm.email ? "8px" : "" },
            attrs: {
              readonly: _vm.isDrop || _vm.readonly,
              placeholder: _vm.placeholder,
              "input-align": _vm.oneline ? "right" : "left",
              clearable: true,
              type: _vm.type,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("click")
              },
              focus: function ($event) {
                return _vm.$emit("focus")
              },
              paste: function ($event) {
                return _vm.$emit("paste")
              },
              blur: function ($event) {
                return _vm.$emit("blur")
              },
            },
            scopedSlots: _vm._u(
              [
                _vm.isDrop
                  ? {
                      key: "right-icon",
                      fn: function () {
                        return [
                          _c("van-icon", {
                            attrs: { name: "arrow-down", color: "#12033a" },
                          }),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
                {
                  key: "button",
                  fn: function () {
                    return [_vm._t("button")]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
            model: {
              value: _vm.content,
              callback: function ($$v) {
                _vm.content = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "content",
            },
          }),
          _vm.email ? _c("span", [_vm._v("Google")]) : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.errorMsg,
              expression: "errorMsg",
            },
          ],
          staticClass: "error",
        },
        [_vm._v(_vm._s(_vm.errorMsg))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }